/**
 * @generated SignedSource<<fd1424e1aa95b3f4824ffceb26ac8d1d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceVersionStatus = "GENERATING_DOI" | "IDLE";
export type WorkspaceDOISubscription$variables = {
  workspaceVersionId: string;
};
export type WorkspaceDOISubscription$data = {
  readonly workspaceVersionUpdate: {
    readonly status: WorkspaceVersionStatus;
    readonly workspaceVersion: {
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDOIFragment">;
    };
  };
};
export type WorkspaceDOISubscription = {
  response: WorkspaceDOISubscription$data;
  variables: WorkspaceDOISubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceVersionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "workspaceVersionId",
    "variableName": "workspaceVersionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceDOISubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "WorkspaceVersionUpdate",
        "kind": "LinkedField",
        "name": "workspaceVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceVersion",
            "kind": "LinkedField",
            "name": "workspaceVersion",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceDOIFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceDOISubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "WorkspaceVersionUpdate",
        "kind": "LinkedField",
        "name": "workspaceVersionUpdate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceVersion",
            "kind": "LinkedField",
            "name": "workspaceVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bibtex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DOI",
                "kind": "LinkedField",
                "name": "doi",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "full",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "short",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5efe905b815dbce6be3f168981bcfc6a",
    "id": null,
    "metadata": {},
    "name": "WorkspaceDOISubscription",
    "operationKind": "subscription",
    "text": "subscription WorkspaceDOISubscription(\n  $workspaceVersionId: ID!\n) {\n  workspaceVersionUpdate(workspaceVersionId: $workspaceVersionId) {\n    status\n    workspaceVersion {\n      ...WorkspaceDOIFragment\n      id\n    }\n  }\n}\n\nfragment WorkspaceDOIFragment on WorkspaceVersion {\n  id\n  bibtex\n  doi {\n    full\n    short\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "8230d6e428a42a8c3c9eb9d77920fb0a";

export default node;
